import React from "react";
import classes from "./CurrentRating.scss";
import I18nHOC from "UIComponents/I18nHOC";
import { getCriteriaValueFromCache } from "modules/CommonGraphqlHelpers";

const CurrentRating = React.memo(props => {
  const { currentRating, t } = props;
  const { label, abbreviation, color } = getCriteriaValueFromCache(
    currentRating
  );
  return (
    <div className={classes.container}>
      <div className={classes.bodyLabel}>
        {t("progressSummary:last_evaluation")}
      </div>
      {currentRating ? (
        <div className={classes.currentRatingValue}>
          <div
            className={classes.criteriaAbbreviation}
            style={{ color }}
          >{`${abbreviation}`}</div>
          <div className={classes.criteriaLabel}>{`(${label})`}</div>
        </div>
      ) : (
        <div className={classes.currentRatingEmptyValue}>{`-`}</div>
      )}
    </div>
  );
});

CurrentRating.displayName = "CurrentRating";

export default I18nHOC({ resource: ["progressSummary"] })(CurrentRating);
